import React, { useState } from 'react';

export default function UnscramblePuzzle({ data, onSolved }) {
  // Support both single word and multiple words
  const words = data.words || [{ scrambled: data.scrambled, answer: data.answer }];

  const [guesses, setGuesses] = useState(words.map(() => ''));
  const [wrongIndexes, setWrongIndexes] = useState([]);
  const [correctIndexes, setCorrectIndexes] = useState([]);
  const [finished, setFinished] = useState(false);

  const handleGuessChange = (index, value) => {
    const newGuesses = [...guesses];
    newGuesses[index] = value;
    setGuesses(newGuesses);
    // Clear wrong/correct state when typing
    setWrongIndexes((prev) => prev.filter((i) => i !== index));
    setCorrectIndexes((prev) => prev.filter((i) => i !== index));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const wrong = [];
    const correct = [];

    words.forEach((word, i) => {
      if (guesses[i].trim().toUpperCase() === word.answer.toUpperCase()) {
        correct.push(i);
      } else {
        wrong.push(i);
      }
    });

    setWrongIndexes(wrong);
    setCorrectIndexes(correct);

    if (wrong.length === 0) {
      setFinished(true);
      setTimeout(onSolved, 1000);
    }
  };

  const allFilled = guesses.every((g) => g.trim() !== '');

  return (
    <div className="puzzle-unscramble">
      <p className="puzzle-prompt">{data.prompt}</p>

      <form onSubmit={handleSubmit}>
        <div className="scramble-words">
          {words.map((word, index) => (
            <div key={index} className="scramble-word-group">
              <div className="scramble-letters">
                {word.scrambled.split('').map((letter, i) => (
                  <span key={i} className="scramble-letter">{letter}</span>
                ))}
              </div>
              <input
                type="text"
                value={guesses[index]}
                onChange={(e) => handleGuessChange(index, e.target.value)}
                placeholder="Unscramble..."
                className={`scramble-input ${wrongIndexes.includes(index) ? 'input-wrong' : ''} ${correctIndexes.includes(index) ? 'input-correct' : ''}`}
                disabled={finished}
              />
            </div>
          ))}
        </div>

        {!finished && (
          <button type="submit" className="puzzle-submit" disabled={!allFilled}>
            Lock it in!
          </button>
        )}
      </form>

      {wrongIndexes.length > 0 && (
        <p className="puzzle-wrong">Not quite! Keep rearranging 🔤</p>
      )}

      {finished && (
        <div className="story-done">
          <span className="story-done-text">You got it! 🎉</span>
        </div>
      )}
    </div>
  );
}
